export var TABLE_TENNIS = 2;
export var BEACH_VOLLEYBALL = 3;
export var VOLLEYBALL = 4;
export var BOX = 5;
export var TENNIS = 6;
export var FOOTBALL = 7;
export var WATER_POLLO = 8;
export var RUGBY = 9;
export var BASEBALL = 10;
export var AMERICAN_FOOTBAL = 11;
export var HOCKEY = 12;
export var LOTTERY = 13;
export var FORMULA1 = 14;
export var SWIMMING = 15;
export var ELECTIONS = 16;
export var ATHLETICS = 17;
export var BEACH_FOOTBALL = 18;
export var HANDBALL = 19;
export var BIATHLON = 20;
export var SKIING = 21;
export var SPECIAL_OFFERS = 22;
export var KVN = 23;
export var POKER = 24;
export var DARTS = 25;
export var CYCLING = 26;
export var WEATHER = 27;
export var WHAT_WHERE_WHEN = 28;
export var SNOOKER = 29;
export var ICE_HOCKEY = 30;
export var BASKETBALL = 31;
export var BADMINTON = 32;
export var OLYMPIC = 33;
export var FUTSAL = 34;
export var BANDY = 35;
export var FLOORBALL = 36;
export var CULTURE = 37;
export var CYBER_SPORTS = 38;
export var MARTIAL_ARTS = 39;
export var CHESS = 40;
export var BASKTBALL_NCAA = 41;
export var CYBER_SPORTS_DOTA2 = 42;



// WEBPACK FOOTER //
// ./src/constants/SportType.js